import React, { FormEvent, useEffect, useState } from 'react';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import LeaseRecording from 'src/models/dlcLease/LeaseRecording';

interface ILeaseRecordingCardComponentProps {
    leaseRecording: LeaseRecording;
    forBatching: boolean;
    disabled: boolean;
    selected: boolean;

    onUpdateLeaseRecording: (leaseNumber: number, id: number) => void;
    handleRecordingSelect: (e: FormEvent<HTMLInputElement>, recordingId: number) => void;
}

const LeaseRecordingCard = (props: ILeaseRecordingCardComponentProps) => {
    const formBuffer = props.forBatching ? 5 : 0;

    const RecordingStatuses = [
        'To Be Recorded',
        'To Be Transmitted',          
        'To Be Assigned',
        'Recorded',
        'Assigned',
        'Transmitted'
    ];

    const [voidOrInvalid, setVoidOrInvalid] = useState<boolean>(false);
    const [isGenerated, setIsGenerated] = useState<boolean>(false);

    useEffect(() => {
        if (!!props.leaseRecording?.lease_invoice) {
            let invoice = props.leaseRecording.lease_invoice;
            setVoidOrInvalid(invoice.void_date !== null && invoice.void_date !== undefined);
        } else {
            setVoidOrInvalid(true);
        }

        if (!!props.leaseRecording?.lease_master) {
            setIsGenerated(props.leaseRecording.lease_master.is_generated === true);
        }
    }, [props]);

    // Ignore the &nbsp; it's just spacing ._. somehow the easiest way
    const recordingStatus = () => {
        let invoice = props.leaseRecording?.lease_invoice;
        let status = props.leaseRecording?.recording_status;

        if (!invoice) {
            // Redish
            return <span style={{color: '#c16363'}}>Invalid Record</span>;
        }

        if (invoice.void_date) {
            // Redish
            return <span style={{color: '#c16363'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Void&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        }
        
        if (props.leaseRecording?.transmit_no !== null && props.leaseRecording?.transmit_no !== undefined) {
            // Default Blue
            return <span>Transferred</span>;
        }
        
        if (props.leaseRecording?.assign_no !== null && props.leaseRecording?.assign_no !== undefined) {
            // Purpleish
            return <span style={{color: '#6963c1'}}>Assigned&nbsp;</span>;
        }

        if (isGenerated) {
            // Green
            return <span style={{color: '#35b83fff'}}>Generated - {(status > 0 && status < 4) ? RecordingStatuses[status - 1] : 'No Status Applied'}&nbsp;</span>;
        }
        
        // Tanish
        return <span style={{color: '#c1b363'}}>{(status > 0 && status < 4) ? RecordingStatuses[status - 1] : 'No Status Applied'}</span>;
    };

    const rightPanel = () => {
        return (
            <>
                <span className="right-panel" style={{marginRight: '1.7rem', whiteSpace: 'nowrap'}}>
                    <span>{recordingStatus()}</span>
                </span>
            </>
        );
    };

    const actions: ContextMenuAction[] = [{ text: 'Manage', action: () => props.onUpdateLeaseRecording(props.leaseRecording.lease_invoice.ls_no, props.leaseRecording.lr_tg) }];

    return (
        <Card
            badge={`${props.leaseRecording?.lease_invoice?.ls_no || 'N/A'}`}
            newContext={true}
            showMenu={!props.forBatching}
            contextActions={actions}
            rightBadgePanel={rightPanel()}
            collapse={true}
        >
            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '1.7rem' }}>
                    {(props.forBatching && !props.disabled) && (
                        <RHFCheckbox
                            style={{ verticalAlign: 'middle' }}
                            bodyStyle={{ width: `${formBuffer}%` }}
                            label=""
                            name={`leaseRecording[${props.leaseRecording.lr_tg}]`}
                            checked={props.selected}
                            onClick={(e) => props.handleRecordingSelect(e, props.leaseRecording.lr_tg)}
                        />
                    )}
                    <div style={{width: `${60 - formBuffer}%`}}>
                        <span 
                            style={voidOrInvalid ? {textDecoration: 'line-through'} : {}} 
                            className="data"
                        >
                            {props?.leaseRecording?.lease_lessor?.name1 || 'N/A'}
                        </span>
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.leaseRecording?.book}
                    </div>
                    <div style={{width: '10%'}}>
                        {props?.leaseRecording?.page}
                    </div>
                    {!props.forBatching && (
                        <>
                            <div style={{width: '10%'}}>
                                {props?.leaseRecording?.assign_no > 0 ? 'Y' : 'N'}
                            </div>
                            <div style={{width: '10%'}}>
                                {props?.leaseRecording?.transmit_no > 0 ? 'Y' : 'N'}
                            </div>
                        </>
                    )}
                    {props.forBatching && (
                        <div style={{width: '20%'}}>
                            {props?.leaseRecording?.working_interest}
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default LeaseRecordingCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/LeaseRecordingCard.tsx